import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import {
    getdiscrepancyCollection,
    DiscrepancyCollectionParam,
    DiscrepancyCollectionResult,
    getdiscrepancyDetails,
    DiscrepancyDetailsParam,
    DiscrepancyDetailsResult,
} from "@tKgpco/Services/DiscrepancyService";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import loadDiscrepancyCollection from "@tKgpco/Store/Data/DiscrepancyHistory/Handlers/loadDiscrepancyCollection";
import loadDiscrepancyMessages from "@tKgpco/Store/Data/DiscrepancyHistory/Handlers/LoadDiscrepancyMessages";

type HandlerType = CustomApiHandler<DiscrepancyDetailsParam, DiscrepancyDetailsResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/BeginLoadDiscrepancyDetailsCollection",
        params: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getdiscrepancyDetails(props.parameter);
};

export const DispatchCompleteDiscrepancyDetailsCollection: HandlerType = props => {
    props.dispatch({
        type: "Custom/DiscrepancyHistory/CompleteLoadDiscrepancyDetailsCollection",
        result: props.apiResult,
    });
};

export const DispatchLoadDiscrepancyCollection: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    const parameters = state.KGPState.DiscrepancyStore.discrepancyCollectionParams;

    props.dispatch(loadDiscrepancyCollection({ ...parameters }));
};

export const DispatchLoadDiscrepancyMessages: HandlerType = props => {
    props.dispatch(loadDiscrepancyMessages({ Id: props.parameter.discrepancyId, type: "DiscHistory", size: 4 }));
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteDiscrepancyDetailsCollection,
    DispatchLoadDiscrepancyCollection,
    DispatchLoadDiscrepancyMessages,
];

export const loadDiscrepancyDetailsCollection = createHandlerChainRunner(chain, "loadDiscrepancyDetailsCollection");
export default loadDiscrepancyDetailsCollection;
